// extracted by mini-css-extract-plugin
var _1 = "Breadcrumbs_active__c141b";
var _2 = "Breadcrumbs_breadcrumbItem__8a23b";
var _3 = "Breadcrumbs_menuOption__ebefd";
var _4 = "Breadcrumbs_wrapper__3a205";
export { _1 as "active", _2 as "breadcrumbItem", _3 as "menuOption", _4 as "wrapper" }
